import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "650",
  height: "58",
  viewBox: "0 0 650 58",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 57.5524L54.1667 45.5965C108.333 33.8198 216.667 9.63953 325 2.60933C433.333 -4.68955 541.667 5.16169 595.833 9.77386L650 14.5651V57.5524H595.833C541.667 57.5524 433.333 57.5524 325 57.5524C216.667 57.5524 108.333 57.5524 54.1667 57.5524H0Z",
      fill: "#FCFAF8"
    }, null, -1)
  ])))
}
export default { render: render }